<ion-app>
  <itl-maintenance-snack-bar>
    <itl-split-pane></itl-split-pane>
  </itl-maintenance-snack-bar>
</ion-app>
